var _rect, _mask, _path, _tspan, _rect2, _tspan2, _rect3, _tspan3, _rect4, _mask2, _path2, _rect5, _rect6, _tspan4, _tspan5, _tspan6, _rect7, _tspan7, _mask3, _path3, _rect8, _rect9, _tspan8, _tspan9, _tspan10, _rect10, _tspan11, _mask4, _path4, _rect11, _rect12, _tspan12, _tspan13, _tspan14, _rect13, _tspan15, _mask5, _path5, _rect14, _rect15, _tspan16, _tspan17, _tspan18, _rect16, _tspan19, _mask6, _path6, _rect17, _rect18, _tspan20, _tspan21, _tspan22, _rect19, _tspan23, _rect20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 452,
    viewBox: "0 0 411 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_45124)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 412,
    rx: 10,
    className: "component-background"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_45124",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V58H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 59H20.5V57H390.5V59ZM20.5 58V10V58ZM390.5 10V58V10Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_45124)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "FORM SENASTE MATCHERNA"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1002_45124)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 68,
    width: 350,
    height: 49,
    rx: 8,
    className: "component-background",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 110.195,
    y: 96.598
  }, "AIK"))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_45124)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 205.5,
    y: 71,
    width: 172,
    height: 43,
    rx: 5,
    className: "component-foreground-id",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 266.92,
    y: 96.598
  }, "IK SIRIUS"))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 68.5,
    width: 349,
    height: 48,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-2_1002_45124",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 127,
    width: 370,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 127,
    width: 370,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 127H390.5V186H20.5V127Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 185H20.5V187H390.5V185Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-11-outside-2_1002_45124)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 143.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E2051B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 144,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 39.8701,
    y: 161.3
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.77,
    y: 150.757
  }, "S\xD6N 4 AUGUSTI"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.5,
    y: 168.939
  }, "IK Sirius - Halmstad BK"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "component-foreground",
    x: 322.5,
    y: 146.5,
    width: 53,
    height: 20,
    rx: 3,
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 333.742,
    y: 161.3
  }, "1 - 2"))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-outside-3_1002_45124",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 186,
    width: 370,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 186,
    width: 370,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 186H390.5V245H20.5V186Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 244H20.5V246H390.5V244Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-20-outside-3_1002_45124)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 202.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E2051B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 203,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 39.8701,
    y: 220.3
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.6377,
    y: 209.757
  }, "S\xD6N 28 JULI"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.5,
    y: 227.939
  }, "Mj\xE4llby AIF - IK Sirius"))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "component-foreground",
    x: 322.5,
    y: 205.5,
    width: 53,
    height: 20,
    rx: 3,
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 333.742,
    y: 220.3
  }, "3 - 0"))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-outside-4_1002_45124",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 245,
    width: 370,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 245,
    width: 370,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 245H390.5V304H20.5V245Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 303H20.5V305H390.5V303Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-29-outside-4_1002_45124)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 261.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E2051B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 262,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 39.8701,
    y: 279.3
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.9058,
    y: 268.757
  }, "S\xD6N 18 JULI"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.5,
    y: 286.939
  }, "IK Sirius - IF Elfsborg"))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "component-foreground",
    x: 323.5,
    y: 264.5,
    width: 52,
    height: 20,
    rx: 3,
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 334.591,
    y: 279.3
  }, "3 - 4"))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-outside-5_1002_45124",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 304,
    width: 370,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 304,
    width: 370,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 304H390.5V363H20.5V304Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 362H20.5V364H390.5V362Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-38-outside-5_1002_45124)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 320.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#3EAB37"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 321,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 38.9678,
    y: 338.3
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.6099,
    y: 327.757
  }, "S\xD6N 12 JULI"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.5,
    y: 345.939
  }, "Kalmar FF - IK Sirius"))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "component-foreground",
    x: 324.5,
    y: 323.5,
    width: 51,
    height: 20,
    rx: 3,
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 335.528,
    y: 338.3
  }, "2 - 2"))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-47-outside-6_1002_45124",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 363,
    width: 370,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 363,
    width: 370,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 363H390.5V422H20.5V363Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 421.5H20.5V422.5H390.5V421.5Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-47-outside-6_1002_45124)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 379.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F29100"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 380,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.9561,
    y: 397.3
  }, "O"))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.9263,
    y: 386.757
  }, "S\xD6N 4 JUNI"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 66.5,
    y: 404.939
  }, "AIK - IK Sirius"))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "component-foreground",
    x: 321.5,
    y: 382.5,
    width: 54,
    height: 20,
    rx: 3,
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 332.647,
    y: 397.3
  }, "0 - 0")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 411,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45124",
    x: 0.5,
    y: 0,
    width: 410,
    height: 452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_45124",
    x: 185.5,
    y: 61,
    width: 212,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_45124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 412,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1002_45124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 68,
    width: 350,
    height: 49,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchform);
export default __webpack_public_path__ + "static/media/matchform.d3d010d3a76d30c4662c95895a7ee63d.svg";
export { ForwardRef as ReactComponent };